import React from 'react';
import PropTypes from 'prop-types';
import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import GeneralSetting from './GeneralSetting';
import PrincipalList from './PrincipalList';
import CostList from './CostList';
import PaymentList from './PaymentList';
import ReturnList from './ReturnList';
import PointList from './PointList';
import TransactionKeyList from './TransactionKeyList';
import CollectionFeeList from './CollectionFeeList';
import BondSetting from '../bondsettings/BondSetting';



const SettingsTab = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }

  return (
    <div>
      {/* <Tab.Container id="left-tabs-example" defaultActiveKey="first">
      <Row>
        <Col sm={3}>
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="first">Tab 1</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second">Tab 2</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={9}>
          <Tab.Content>
            <Tab.Pane eventKey="first">
              <Sonnet />
            </Tab.Pane>
            <Tab.Pane eventKey="second">
              <Sonnet />
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container> */}

      <div className="grid">              
        <div className="col s4of12">
          <GeneralSetting data={data} />
        </div>
        <div className="col s4of12"> 
          <CollectionFeeList calculateToDate={data.calculateTo} data={data} />         
        </div>      
        <div className="col s4of12">
          {!data.isBond && <PrincipalList data={data}/>}
        </div>
      </div>
      <div className="grid">              
        <div className="col s8of12">
          <PaymentList data={data} />
        </div>
        <div className="col s4of12">
          <CostList data={data}/>
        </div>
      </div>
      <div className="grid">              
        <div className="col s4of12">
          <ReturnList data={data} />
        </div>
        <div className="col s2of12">
          <PointList title="VSK tafla" isPercent={true} hasExtra={false} points={data.vatTable.points}  calculateToDate={data.calculateTo} oldestDueDate={data.oldestDueDate}/>
        </div>
        <div className="col s2of12">
          <PointList title="FTS tafla" isPercent={true} hasExtra={false} points={data.capitalGainsTaxTable.points}  calculateToDate={data.calculateTo} oldestDueDate={data.oldestDueDate}/> 
        </div>
        <div className="col s2of12">          
          
        </div>        
      </div>
      <div className="grid">              
        <div className="col s6of12">        
        </div>
      </div>
      <div className="grid">              
        <div className="col s10of12">
          <TransactionKeyList data={data}/>
        </div>
      </div>
    </div>
  );
};

SettingsTab.propTypes = {
  data: PropTypes.object,
};

export default SettingsTab;
